import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <footer className="pt-10 md:pt-20 bg-[#07051d]">
        <div className="theme-container mx-auto flex flex-wrap justify-between mb-20 gap-5">
          <div className="w-fit max-w-[300px]">
            <img src="assets/images/footer-logo.png" alt="logo" />
            <p className="max-w-[300px] text-white my-6">
            We are a movement toward mindful living,
                  conscious choices, and natural solutions that restore your
                  body’s true harmony. Truvana Health - Wellness in Every
                  Breath
            </p>
           
          </div>
          <div className="w-fit max-w-[300px]">
            <div className="max-w-[223px]">
              <h1 className="font-semibold text-18 text-white">Address</h1>
              <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 mt-3.5">
                <span className="transition-all duration-300">
                  UGF- 71- Upper Ground Ansal Plaza - 2 Chiranjiv Vihar Ghaziabad ( U P )- 201002
                </span>
              </div>
              <h1 className="font-semibold text-18 text-white mt-6">Contact</h1>
              <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 mt-3.5">
                <span className="transition-all duration-300">
                  <a
                    href="mailto:support@truvanaopd.com"
                  >
                    support@truvanaopd.com
                  </a>
                  <br />
                  +91-9211226940
                </span>
              </div>
            </div>
          </div>
          <div className="w-fit max-w-[300px]">
            <div className="flex flex-col items-center">
              <div>
                <h1 className="font-semibold text-18 text-white">
                  Qwick Links
                </h1>
                <ul className="mt-3.5">
                  <li className="mt-2">
                    <Link to="/">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Home
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/plans">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Plans
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/contact">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Contact
                        </span>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="w-fit max-w-[300px]">
            <div className="flex flex-col items-center">
              <div>
                <h1 className="font-semibold text-18 text-white">
                  Terms & Policies
                </h1>
                <ul className="mt-3.5">
                  <li className="mt-2">
                    <Link to="/term-of-use">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Term of Use
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/privacy-policy">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Privacy Policy
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/cancellation-policy">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Cancellation Policy
                        </span>
                      </div>
                    </Link>
                  </li>
                  <li className="mt-2">
                    <Link to="/shipping-delivery-policy">
                      <div className="flex gap-2 items-center relative group font-medium text-white hover:text-white transition-all duration-300 overflow-hidden">
                        <svg
                          className="absolute -left-2 transition-all duration-300 group-hover:left-0"
                          width="6"
                          height="12"
                          viewBox="0 0 6 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L5 6L1 11"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="group-hover:translate-x-4 transition-all duration-300">
                          Shipping And Delivery Policy
                        </span>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
        </div>
        <div className="w-full h-[80px] md:h-[65px] bg-[#060418]">
          <div className="theme-container mx-auto h-full">
            <div className="w-full h-full flex flex-wrap justify-between items-center">
              <span className="text-white max-w-100">
                2025 © All rights reserved by &nbsp;
                <b className="text-white">Truvana Health</b>
              </span>
              <div className="relative w-full sm:w-fit flex justify-center">
                <a
                  href="#top"
                  aria-label="go top"
                  className="w-[45px] h-[45px] rounded-full border-[3px] border-[#323239] flex justify-center items-center bg-blue-sass absolute -top-[75px] sm:-top-[55px] max-[768px]:right-0"
                >
                  <span>
                    <svg
                      width="45"
                      height="45"
                      viewBox="0 0 45 45"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="22.5"
                        cy="22.5"
                        r="21"
                        fill="#4A7DFF"
                        stroke="#323239"
                        stroke-width="3"
                      />
                      <path
                        d="M19 21L23 17M23 17L27 21M23 17V29"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
